import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type ModerationSetStatusMutationVariables = Types.Exact<{
  surface: Types.ModerationSurface
  itemId: Types.Scalars['ID']['input']
  status: Types.CommentStatus
}>

export type ModerationSetStatusMutation = {
  __typename?: 'Mutation'
  moderationSetStatus?: {
    __typename?: 'Comment'
    id?: string | null
    status?: Types.CommentStatus | null
  } | null
}

export const ModerationSetStatusDocument = gql`
  mutation ModerationSetStatus(
    $surface: ModerationSurface!
    $itemId: ID!
    $status: CommentStatus!
  ) {
    moderationSetStatus(surface: $surface, itemId: $itemId, status: $status) {
      id
      status
    }
  }
`
export type ModerationSetStatusMutationFn = Apollo.MutationFunction<
  ModerationSetStatusMutation,
  ModerationSetStatusMutationVariables
>

/**
 * __useModerationSetStatusMutation__
 *
 * To run a mutation, you first call `useModerationSetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModerationSetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moderationSetStatusMutation, { data, loading, error }] = useModerationSetStatusMutation({
 *   variables: {
 *      surface: // value for 'surface'
 *      itemId: // value for 'itemId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useModerationSetStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ModerationSetStatusMutation,
    ModerationSetStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ModerationSetStatusMutation, ModerationSetStatusMutationVariables>(
    ModerationSetStatusDocument,
    options,
  )
}
export type ModerationSetStatusMutationHookResult = ReturnType<
  typeof useModerationSetStatusMutation
>
export type ModerationSetStatusMutationResult = Apollo.MutationResult<ModerationSetStatusMutation>
export type ModerationSetStatusMutationOptions = Apollo.BaseMutationOptions<
  ModerationSetStatusMutation,
  ModerationSetStatusMutationVariables
>
